import { createContext } from 'react';

import { UserTokenInfo } from './types';

export type UserContextType = {
  user: UserTokenInfo | null;
  setUser: (user: UserTokenInfo | null) => void;
  credits: number;
  setCredits: (credits: number) => void;
};

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: (user: UserTokenInfo | null) => {
    return;
  },
  credits: 0,
  setCredits: (credits: number) => {
    return;
  },
});

export default UserContext;

export function hasPermission(user: UserTokenInfo | null, permission: string): boolean {
  if (!user) {
    return false;
  }

  return user.permissions.includes(permission);
}

export function hasPermissions(user: UserTokenInfo | null, permissions: string[]): boolean {
  if (!user) {
    return false;
  }

  return permissions.every((permission) => user.permissions.includes(permission));
}
